import { baseUrl } from "constant";
import { PayRollEndpointConst, getEmployeeCTCbyCodeUrl, getEmployeeCTCbyIdUrl, getEmployeeInfoByCodeUrl, getSalarySheetUrl, getSalaryYearUrl, validatePreviousContractUrl } from "./const";
import { RootState } from "store/store";
import { getAuthToken } from "utils/getAuthToken";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import {
    IEmployeeSalaryResponseType, IGetEmployeeCTCByCodeRequestType, IGetEmployeeInfoByCodeType, IGetEmployeeSalarySheetType, IGetHoldHistoryType, IPaginationResponseType,
    IResponseType, ISalaryDeleteRequestType, ISalaryRequestParamType
} from "./type";
import { IApprovedDeclindSalaryStaus, ICtcRequestType, IEmployee, IEmployeeSalaryType, IGenerateSalaryType, IGetEmployeeCTCByCodeResType, IGetEmployeeInfoType, IGetEmployeeRemainedSalaryListRequest, IGetEmployeeSalaryCertificateObjType, IGetEmployeeSalaryCertificateRequestType, IGetEmployeeSalaryListRequest, IGetPartlyDetailsType, IHoldSalaryStatusObjDataType } from "../employeeSalary/types";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { IGetHoldEmployeeSalaryListRequest, IHoldEmployeeSalaryType } from "../holdSalary/types";
import { downloadFile } from "utils/handleFIleDownload";

export const payRollsApi = createApi({
    reducerPath: "payRollsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['PayRolls'],
    endpoints: (builder) => ({
        GetEmployeeSalaryList: builder.mutation<IPaginationResponseType<IEmployeeSalaryResponseType>, IGetEmployeeSalaryListRequest>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getEmployeeSalaryListUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalaryLists' }],
        }),
        GetTraineeSalaryList: builder.mutation<IPaginationResponseType<IEmployeeSalaryResponseType>, IGetEmployeeSalaryListRequest>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getTraineeSalaryListUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalaryLists' }],
        }),
        AddEditEmployeeSalary: builder.mutation<IResponseType<string>, IGenerateSalaryType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.generateSalaryUrl,
                method: 'POST',
                body: userReq.generateSalaryObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'AddEditEmployeeSalary' }],
        }),
        GetOverTimeData: builder.mutation<IResponseType<number>, ISalaryRequestParamType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getSalaryOverTimeUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetOverTimeData' }],
        }),
        GetLeaveWitoutPayData: builder.mutation<IResponseType<number>, ISalaryRequestParamType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getSalaryLWPUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetLeaveWitoutPayData' }],
        }),
        GetSalaryDetail: builder.mutation<IResponseType<IEmployeeSalaryType>, ISalaryRequestParamType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getSalaryDetails,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetSalaryDerails' }],
        }),
        DeleteSalary: builder.mutation<IResponseType<boolean>, ISalaryDeleteRequestType>({
            query: userReq => ({
                url: PayRollEndpointConst.deleteSalaryUrl,
                method: 'DELETE',
                body: userReq.salaryId
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'DeleteSalary' }],
        }),
        UpdateEmployeeSalaryStatus: builder.mutation<IResponseType<number>, IApprovedDeclindSalaryStaus>({
            query: (userReq) => ({
                url: PayRollEndpointConst.updateSalaryStatusUrl,
                method: 'PUT',
                body: userReq.approvedDeclindSalaryStatusObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'UpdateEmployeeSalaryStatus' }],
        }),
        GetEmployeeInfoByCode: builder.query<IResponseType<IGetEmployeeInfoType>, IGetEmployeeInfoByCodeType>({
            query: (param) => getEmployeeInfoByCodeUrl(param),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'UpdateEmployeeSalaryStatus' }]
        }),
        GetPartlyDetailsData: builder.mutation<IResponseType<IGetPartlyDetailsType[]>, ISalaryRequestParamType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getPartlyDetailsUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetPartlyDetailsData' }],
        }),
        CheckSalaryExists: builder.mutation<IResponseType<boolean>, ISalaryRequestParamType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.checkSalaryExists,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'CheckSalaryExists' }],
        }),
        GetEmployeeSalaryYear: builder.mutation<IResponseType<number[]>, IGetEmployeeInfoByCodeType>({
            query: (userReq) => ({
                url: getSalaryYearUrl(userReq),
                method: 'POST',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalaryYear' }],
        }),
        HoldSalary: builder.mutation<IResponseType<string>, IHoldSalaryStatusObjDataType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.holdSalaryUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'HoldSalary' }],
        }),
        HoldSalaryEmployees: builder.mutation<IPaginationResponseType<IHoldEmployeeSalaryType>, IGetHoldEmployeeSalaryListRequest>({
            query: (userReq) => ({
                url: PayRollEndpointConst.holdSalaryEmployeesUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'HoldSalary' }],
        }),
        GetHoldHistory: builder.mutation<IPaginationResponseType<IHoldEmployeeSalaryType>, IGetHoldHistoryType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getHoldSalaryHistoryUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'HoldSalary' }]
        }),
        DeleteHoldSalary: builder.mutation<IResponseType<boolean>, ISalaryDeleteRequestType>({
            query: userReq => ({
                url: PayRollEndpointConst.deleteHoldSalaryUrl,
                method: 'DELETE',
                body: userReq.salaryId
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'DeleteSalary' }],
        }),
        GetEmployeeRemainedSalaryList: builder.mutation<IPaginationResponseType<IEmployee[]>, IGetEmployeeRemainedSalaryListRequest>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getEmployeeRemainedSalaryListUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalaryLists' }],
        }),
        GetEmployeeSalarySheet: builder.query<IResponseType<string>, IGetEmployeeSalarySheetType>({
            query: (userReq) => ({
                url: getSalarySheetUrl(userReq),
                method: 'GET',
                responseHandler: async (response) => {
                    downloadFile(response)
                },
                cache: "no-cache",
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalarySheet' }],
        }),
        GetEmployeeSalaryCertificate: builder.mutation<IResponseType<IGetEmployeeSalaryCertificateObjType>, IGetEmployeeSalaryCertificateRequestType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.getEmployeeSalaryCertificateUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'GetEmployeeSalaryCertificate' }],
        }),
        GetEmployeeCTCByCode: builder.query<IResponseType<IGetEmployeeCTCByCodeResType>, IGetEmployeeCTCByCodeRequestType>({
            query: (param) => getEmployeeCTCbyCodeUrl(param),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'GetEmployeeCTCByCode' }]
        }),
        GetEmployeeCTCById: builder.query<IResponseType<IGetEmployeeCTCByCodeResType>, IGetEmployeeCTCByCodeRequestType>({
            query: (param) => getEmployeeCTCbyIdUrl(param),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'GetEmployeeCTCById' }]
        }),
        UpdateEmployeeCtcCalculation: builder.mutation<IResponseType<string>, ICtcRequestType>({
            query: (userReq) => ({
                url: PayRollEndpointConst.updateEmployeeCTCcalculationUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'PayRolls', id: 'UpdateEmployeeCtcCalculation' }],
        }),
        GetEmployeeDesignation: builder.query<IResponseType<string>, void>({
            query: () => ({
                url: PayRollEndpointConst.getEmployeeDesignationUrl,
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'GetEmployeeDesignation' }]
        }),
        ValidatePreviousContract: builder.query<IResponseType<number[]>, IGetEmployeeInfoByCodeType>({
            query: (userReq) => ({
                url: validatePreviousContractUrl(userReq),
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'PayRolls', id: 'ValidatePreviousContract' }],
        })
    })
})
